import React from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Navbar />

      {/* Hero */}
      <section id="home">
        <HeroSection />
      </section>

      {/* Services */}
      <section id="services">
        <ServicesSection />
      </section>

      {/* Contact */}
      <section id="contact">
        <ContactSection />
      </section>

      <Footer />

      {/* Floating Call Button */}
      <a 
        href="tel:+918008105100" 
        className="float-call"
      >
        📞 Call Now
      </a>

      {/* Floating WhatsApp Button */}
      <a 
        href="https://wa.me/918008105100?text=Hello%20Vuzenik%20Technologies%2C%20I%20want%20to%20know%20more." 
        target="_blank" 
        rel="noopener noreferrer"
        className="float-whatsapp"
      >
        💬 WhatsApp
      </a>
    </div>
  );
}

export default App;
